import { makeVar } from '@apollo/client'
import { ApprovalDeal } from 'ts/interfaces/approvalDeal.interface'

export const selectedApprovalRowsVar = makeVar<ApprovalDeal[]>([])
